export enum SubscriptionStatus {
  TRIAL = "trialing",
  GRACE = "grace",
  HARDDEADLINE = "harddeadline",
  POSTHARDDEADLINE = "postharddeadline",
  ACTIVE = "active",
  INACTIVE = "inactive",
}
